import api from "./Api";

class ProdutoTributacaoService {
  GetProdutoTributacao(payload) {
    return api.get("/v1/produtoTributacao/" + payload).then((response) => {
      return response.data;
    });
  }

  PostProdutoTributacao(payload) {
    return api.post("/v1/produtoTributacao/", payload).then((response) => {
      return response.data;
    });
  }

  PutProdutoTributacao(payload) {
    return api.put("/v1/produtoTributacao/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteProdutoTributacao(payload) {
    return api.delete("/v1/produtoTributacao/" + payload).then((response) => {
      return response.data;
    });
  }

  GetProdutoTributacaoOData(payload) {
    return api.get("/OData/ProdutoTributacao" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new ProdutoTributacaoService();
